module.exports = __webpack_public_path__ + "static/media/bissi.7467b8c6.png";